<template>
  <div id="home">
    <span
      style="font-size: 17px;"
      v-html="getHomeMessage"
    />
    <v-data-iterator
      :items="getHomeItems"
      hide-actions
      content-tag="v-layout"
      align-center
      expand
      loading
      wrap
    >
      <v-flex
        slot="item"
        slot-scope="props"
        style="padding: 3px;"
        xs12
        sm6
        md6
        lg4
        xl3
      >
        <homecard
          :img="props.item.image"
          :title="props.item.title"
          img-height="210px"
          :link="props.item.link"
        >
          <slot />
        </homecard>
      </v-flex>
    </v-data-iterator>
  </div>
</template>

<script>
import HomeCard from 'components/HomeCard.vue'
export default {
  components: {
    'homecard': HomeCard
  },
  computed: {
    getHomeMessage: function () {
      return this.$t('variables.homeMessage')
    },
    getHomeItems: function () {
      return this.$t('variables.homeItem')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/contents/Home.vue